/**
 * Check if the list is after a table
 * @param {Node} doc - The document object
 * @param {Node} list - The list node
 * @param {Object} selection - The selection object
 * @returns {boolean} - True if the list is after a table, false otherwise
 */
const checkIfAfterTable = (doc, list, { from }) => {
    let isAfterTable = false;

    doc.nodesBetween(0, from, (node, _pos, parent) => {
        if (node.type.name === "table") {
            isAfterTable = true;
        }

        if (node === list && isAfterTable) {
            return true;
        } else if (!node.type.name.includes("table") && !node.type.name.includes("listItem")) {
            if (node.type.name !== "paragraph" && !parent.type.name.includes("table")) {
                isAfterTable = false;

                return true;
            }
        }
    });

    return isAfterTable;
};

/**
 * Check if the list is the first list item
 * @param {Node} doc - The document object
 * @param {Node} listItem - The list item node
 * @param {Object} selection - The selection object
 * @returns {boolean} - True if the list is the first list item, false otherwise
 */
const checkIfFirstListItem = (doc, listItem, { from }) => {
    let isFirstListItem = false;

    doc.nodesBetween(0, from, (node) => {
        if (node.type.name === "listItem" && node === listItem) {
            isFirstListItem = true;
            return true;
        } else if (node.type.name === "listItem") {
            isFirstListItem = false;
            return true;
        }
    });

    return isFirstListItem;
};

// Supported ordered-list numbering schemes (CSS list-style-type names).
const DEFAULT_LIST_STYLE_TYPE = "decimal";
const LIST_STYLE_TYPES = ["decimal", "lower-alpha", "upper-alpha", "lower-roman", "upper-roman"];

// Word's multilevel ladder: each nested level steps to the next scheme, and the
// last three cycle forever (A > a > i > 1 > a > i > 1 ...).
const NEXT_LIST_STYLE_TYPE = {
    "upper-roman": "upper-alpha",
    "upper-alpha": "lower-alpha",
    "lower-alpha": "lower-roman",
    "lower-roman": "decimal",
    decimal: "lower-alpha",
};

/**
 * Numbering scheme `steps` nesting levels below `listStyleType`.
 * @param {string} listStyleType - The scheme of the ancestor list
 * @param {number} steps - How many levels below that ancestor
 * @returns {string} - The scheme for that level
 */
const nextListStyleType = (listStyleType, steps) => {
    let value = listStyleType;

    for (let step = 0; step < steps; step++) {
        value = NEXT_LIST_STYLE_TYPE[value] || DEFAULT_LIST_STYLE_TYPE;
    }

    return value;
};

export {
    checkIfAfterTable,
    checkIfFirstListItem,
    LIST_STYLE_TYPES,
    DEFAULT_LIST_STYLE_TYPE,
    nextListStyleType,
};
